import { AfterViewChecked, Component, ElementRef, Input, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { MatMenuModule } from '@angular/material/menu';
import { PlanCardComponent } from '../plan-card/plan-card.component';
import { CustomerSearchComponent } from '../customer-search/customer-search.component';
import { UpgradeMessageComponent } from '../../../../upgrade-message/upgrade-message.component';
import { TimezoneDatePipe } from '../../../../timezone-date.pipe';
import { underscoreRemovePipe } from '../../../../pipe/UnderscopeRemove';
import { NetworkTypeLabelPipe } from '../../../../pipe/network-type-label.pipe';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { BsModalService } from 'ngx-bootstrap/modal';
import { debounceTime, Observable, Subscription } from 'rxjs';
import { BENEFITS_KEY } from 'src/app/components/Price-subscritions/priceplanService';
import { ApiService } from 'src/app/services/api.service';
import { ExcelService } from 'src/app/services/excelService';
import { FormValidation } from 'src/app/services/FormValidation';
import { GigsumoConstants } from 'src/app/services/GigsumoConstants';
import { UtilService } from 'src/app/services/util.service';
import Swal from 'sweetalert2';
import { CustomerService, TEXT_FIELDS } from '../customer-service.service';
import { NodataFoundComponent } from '../../../../widget/nodata-found/nodata-found.component';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';


@Component({
  selector: 'app-business-networks',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    NgxDatatableModule,
    MatMenuModule,
    PlanCardComponent,
    CustomerSearchComponent,
UpgradeMessageComponent,
    TimezoneDatePipe,
    underscoreRemovePipe,
    NetworkTypeLabelPipe,
    NodataFoundComponent
  ,
    NG_ICON_DIRECTIVES,
  ],
  templateUrl: './business-networks.component.html',
  styleUrls: ['./business-networks.component.scss','../../../../../styles/admin/style.scss','../../../../../styles/admin/app.scss']
})
export class BusinessNetworksComponent extends FormValidation implements OnInit , OnDestroy, AfterViewChecked {
  PLANMAX : number = 0;
  AVAILABLE : number = 0;
  ALLOCATED : number = 0;
  businessDetails:any
  contactData:any
  textFields: Array<Partial<TEXT_FIELDS>>;
  @Input() screenName: string;
  networkDetailForm: FormGroup;
  private modalRef: NgbModalRef;
  businessId: any;
  refreshSubcription: Subscription;
  filterSubscription: Subscription;
  searchSubscription: Subscription;
  MemberShipType :any;
  isBusinessOrEnterpriseUser: boolean = false;
  allocationCards: { name: string; value: number }[] = [];
  role:any
  constructor(
    private router: Router,
    private _activated_route: ActivatedRoute,
    private apiService: ApiService,
    private modalService1: BsModalService,
    private customerService: CustomerService,
    private excel: ExcelService,
    private renderer: Renderer2, private el: ElementRef,
    private modalService: BsModalService,
  private util:UtilService) {
    super();

    this.refreshSubcription =  this.customerService.getRefreshKey().subscribe(ress=>{
      if(ress === "businessNetworks"){
        this.nextPage({offset: 0})
      }
    });

    this.filterSubscription = this.customerService.getFilterValue().subscribe(res=>{
      if(res.key === 'businessNetworks'){
        this.params.page = 0;
        this.params.statusList = res.value.status==null?res.value.status:[res.value.status];
        this.params.type = res.value.type
        this.params.searchContent = null;
        this.customerService.setFilterPayload(this.params);
        this.getB2BNetworks();
      }
    });


    this.searchSubscription = this.customerService.getSearchValue().pipe(
      debounceTime(1000),
    ).subscribe(response =>{
      if(response.key === "businessNetworks"){
        this.params.page = 0;
        this.params.searchContent = response.value

        this.getB2BNetworks();
      }
    });


    this.networkDetailForm = new FormGroup({
      b2bNetworkName: new FormControl(null, [Validators.required, Validators.pattern("^[A-Za-z ]+$")]),
    });

    // Find the route with resolver data by walking up the tree
    // For nested routes under componentless wrappers, data may be at parent or parent.parent
    let routeWithData = this._activated_route.parent;
    while (routeWithData && !routeWithData.snapshot.data['data']) {
      routeWithData = routeWithData.parent;
    }

    if (routeWithData) {
      routeWithData.data.subscribe(res => {
        if (res?.data) {
          this.businessDetails = res.data;
          this.businessId = this.businessDetails.id;
          this.MemberShipType = this.businessDetails.plan;
          this.role = this.businessDetails.role;

          // Initialize after MemberShipType is available
          this.initializeAllocationCards();
          this.checkUserPlan(this.MemberShipType);
        }
      });
    }

    this.textFields = [
      {label : "Network Name"  , key :  "b2bNetworkName" , value : null , type : "STRING"},
      {label : "Network Type"  , key :  "type" , value :null  ,  type : "STRING"},
      {label : "Owner"  , key :  "userName" , value : null , type : "STRING"},
      {label : "Email"  , key :  "email" , value : null , type : "STRING"},
      {label : "Role"  , key :  "userType" , value : "Super Admin" ,  type : "STRING"},
      {label : "Members"  , key :  "membersCount" , value : null ,  type : "STRING"},
      {label : "Created Date"  , key :  "createdOn" , value : null ,  type : "DATE"},
      {label : "Last Active"  , key :  "modifiedOn" , value : null ,  type : "DATE"},
      {label : "Status"  , key :  "status" , value : null ,  type : "STRING"},
    ]
  }

  public listToShow: Array<any> = []

  public selected = [];
  ngOnInit(): void {
    this.getB2BNetworks();
  }
  checkUserPlan(memberShipType: string) {
    this.isBusinessOrEnterpriseUser = this.customerService.isBusinessOrEnterprise(memberShipType);
  }

  initializeAllocationCards() {
    const defaultValues = this.MemberShipType === "Free"
      ? [5, 0, 5]
      : [null, null, null];

    const cardNames = ["Plan Max", "Allocated", "Available"];
    this.allocationCards = cardNames.map((name, index) => ({
      name,
      value: defaultValues[index],
    }));
  }
  scrollSynced = false;
  bodyScrollUnlistener: () => void;
  resizeUnlistener: () => void;

  ngAfterViewChecked() {
    const dataTableBody = this.el.nativeElement.querySelector('.datatable-body');
    const dataTableHeader = this.el.nativeElement.querySelector('.datatable-header');

    if (!this.isFirefox()) {
      // If it's not Firefox, no need for custom scroll handling
      return;
    }

    if (dataTableBody && dataTableHeader && !this.scrollSynced) {
      // Clean up any previous listeners to avoid duplicates
      if (this.bodyScrollUnlistener) {
        this.bodyScrollUnlistener();
      }
      if (this.resizeUnlistener) {
        this.resizeUnlistener();
      }

      // Scroll listener to sync body and header scrolls
      this.bodyScrollUnlistener = this.renderer.listen(dataTableBody, 'scroll', this.throttle(() => {
        dataTableHeader.scrollLeft = dataTableBody.scrollLeft;
      }, 10)); // Throttle the scroll event to improve performance

      // Listener for window resize to ensure the header remains aligned
      this.resizeUnlistener = this.renderer.listen(window, 'resize', () => {
        dataTableHeader.scrollLeft = dataTableBody.scrollLeft;
      });

      this.scrollSynced = true; // Mark scroll syncing as done
    }
  }

  // Browser detection function to check if the browser is Firefox
  isFirefox(): boolean {
    return navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
  }


  throttle(fn: Function, wait: number) {
    let time = Date.now();
    return function () {
      if ((time + wait - Date.now()) < 0) {
        fn();
        time = Date.now();
      }
    };
  }


  ngOnDestroy(): void {

    if(this.refreshSubcription){
      this.refreshSubcription.unsubscribe();
    }

    if(this.filterSubscription){
      this.filterSubscription.unsubscribe();
    }

    if(this.searchSubscription){
      this.searchSubscription.unsubscribe();
    }

    if (this.bodyScrollUnlistener) {
      this.bodyScrollUnlistener();
    }

    if (this.resizeUnlistener) {
      this.resizeUnlistener();
    }
  }

  businessName: string;
  bid: string;


  params: any = {
    limit: 10,
    page : 0,
    total: 0,
  };

  closeModal() {
    this.modalService1.hide(this.modalService1.getModalsCount());
  }

  saveNetwork() {
    if (this.networkDetailForm.valid) {
      let payload = {
        ...this.networkDetailForm.value,
        networkOwnerId: localStorage.getItem('userId')
      };
      this.apiService.create("business/createB2BNetwork", payload).subscribe((res) => {
        if (res.code == "00000") {
          this.modalRef.close();
          Swal.fire({
            icon: "success",
            title: "",
            showConfirmButton: false,
            timer: 2000,
          });
        } else if (res.code == "99999") {
          Swal.fire({
            icon: "info",
            title: "Network already exist",
            showConfirmButton: false,
            timer: 5000,
          });
        }
      }, err => {
      });
    }
  }




  updateRowStatus(updatedRow: any, status: string) {
    this.listToShow = this.listToShow.map(row => {
        if (row.platformBusinesId === updatedRow.platformBusinesId) {
            row.connectionStatus = status;
        }
        return row;
    });
  }

  openViewModal(datas : any){


    if(datas){
      Object.keys(datas).map(key=>{
        this.textFields.forEach(vv=>{

          if(vv.label === "Allocated" || vv.label === 'Available'){
            vv.value = this.curryObject(datas , 'benefitsUsageAndBalance')(vv.label === "Allocated" ? "actual" : "available");
            return;
          }

          if(vv.key == key) {
            if (key === 'type' && typeof datas[key] === 'string'
              && datas[key].trim().toLowerCase() === 'client_supplier') {
              // Backend stores the canonical "Client_Supplier"; show "Client/Supplier"
              // in the details popup, matching the listing column's networkTypeLabel pipe.
              vv.value = 'Client/Supplier';
            } else {
              vv.value = datas[key];
            }
          }

        });
      });
    }

    if(this.textFields){
      this.openView("Network Details" , this.textFields , this.modalService,this.util);
    }

  }
  @ViewChild('sortTable') table: any;
  onSort(event) {
    const currentPage = this.params.page-1;
    this.table.offset = currentPage;
}
  showModal : boolean = false;
  selectedItem: string = 'businessNetworks';
  getB2BNetworks() {
    this.util.startLoader();
    this.params.businessId =  this.businessId;
    this.getNetworkList(this.params)
      .subscribe({

        next: (res) => {
          if(res) {
            this.util.stopLoader();
          }
          if (res && res.code === GigsumoConstants.SUCESSCODE) {
            const networkData = res.data?.b2bNetworks;
            this.listToShow = networkData ? networkData : [];
            this.params.total = res.data?.total || 0;

            if (this.listToShow.length === 0) {
              this.params.total = 0;
            }

            this.listToShow.forEach(network => {
              if (network.userData) {
                network.userName = `${network.userData.firstName} ${network.userData.lastName}`;
                network.email = network.userData.email;
              }
            });
            this.excel.setCount(res.data?.total);
            let plan = res.data.businessPlanUsage

            if(plan){

                let found =  (plan.benefitsUsages && plan.benefitsUsages.
                  find(x => (x.benefitKey as BENEFITS_KEY) === 'B2B_NETWORKS'));
                  let membershipType = res.data.businessPlanUsage.membershipType;
                if(found){
                  this.PLANMAX = found.actual == 99999999 ? 'Unlimited' : found.actual;
                  this.AVAILABLE = found.actual == 99999999 ? 'Unlimited' : found.available;
                  this.ALLOCATED = found.utilized;
                  this.allocationCards = [
                    { name: "Plan Max", value: this.PLANMAX },
                    { name: "Allocated", value: this.ALLOCATED },
                    { name: "Available", value: this.AVAILABLE },
                  ];
                }
                if (found && membershipType) {
                  let plandetails = {
                    actual:found.actual,
                    available: found.available,
                    promotional:found.promotional,
                    utilized:found.utilized,
                    membershipType:membershipType
                  };
                }

            }

          }
        },
        error: (error) => {
          this.util.stopLoader();
          console.error('Subscribe Error:', error); // Log any error in the subscribe block
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "An error occurred while fetching data. Please try again later.",
          });
        }
      });
  }

  getNetworkList(payload: Object): Observable<any> {
    return this.apiService.create('business/findB2BNetworks', payload);
  }

  onSelect({ selected }) {
    this.selected.splice(0, this.selected.length);
    this.selected.push(...selected);
  }
  nextPage(data: any) {
    this.params.page = data.offset+1;
    if (this.params.page == 1) {
      this.params.page = 1;
    }
    this.util.startLoader()
    this.getB2BNetworks();
  }
  getNetworkParams(row){

    return {...this.businessDetails , businessNetworkId : row.b2bNetworkId , };
  }



}
